import React from 'react';
import { motion } from 'framer-motion';

const AchievementCard = ({ achievement, isUnlocked, language }) => {
  return (
    <motion.div
      className={`rounded-lg overflow-hidden border-2 ${
        isUnlocked 
          ? achievement.special 
            ? 'border-amber-300 dark:border-amber-700 bg-gradient-to-br from-white to-amber-50 dark:from-gray-750 dark:to-amber-900/20' 
            : 'border-love-300 dark:border-love-700 bg-gradient-to-br from-white to-love-50 dark:from-gray-750 dark:to-love-900/30' 
          : 'border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-800 opacity-60'
      } hover:shadow-md transition-shadow relative`}
      whileHover={isUnlocked ? { scale: 1.02, y: -3 } : {}}
      transition={{ duration: 0.2 }}
    >
      {/* Special achievement indicator with improved visibility */}
      {achievement.special && (
        <div className="absolute top-0 left-0 w-10 h-10 flex items-center justify-center">
          <span className="text-2xl text-amber-500 drop-shadow-md">🏆</span>
        </div>
      )}
      
      <div className={`p-3 ${achievement.special ? 'mt-4' : ''}`}>
        <div className="flex items-center">
          <div className={`text-3xl mr-3 ${isUnlocked && achievement.special ? 'animate-pulse-slow' : ''}`}>
            {achievement.icon}
          </div>
          <div>
            <div className="font-semibold text-gray-800 dark:text-gray-200 flex items-center">
              {achievement.name}
              {achievement.special && (
                <span className="ml-1.5 text-xs px-1.5 py-0.5 bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300 rounded-full">
                  ✨ {language === 'zh' ? '特殊' : 'Special'}
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {achievement.description}
            </div>
            <div className="text-xs mt-1 font-medium text-love-600 dark:text-love-300">
              {achievement.days} {language === 'zh' ? '天' : 'days'}
            </div>
          </div>
        </div>
      </div>
      
      {!isUnlocked && (
        <div className="bg-gray-200 dark:bg-gray-700 text-center text-xs py-1 text-gray-600 dark:text-gray-400">
          {language === 'zh' ? '尚未解鎖' : 'Not yet unlocked'}
        </div>
      )}
    </motion.div>
  );
};

export default AchievementCard;